
import { createI18n } from 'vue-i18n'
import zh_CN from './zh-CN'
import en_US from './en'
import tr_TR from './tr_TR'

const i18n = createI18n({
    legacy: false,
    locale: 'zh_CN',
    messages: {
        zh_CN,
        en_US,
        tr_TR
    }
})

export default i18n;